import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analyticsPromise } from '../firebase';

// GA4 auto-logs one page_view on initial load, but this is a client-side
// routed SPA, so every subsequent navigation (Home to FAQ, FAQ to Support,
// and so on) needs its own manual page_view or GA would only ever see a
// single pageview for the entire visit no matter how many pages someone
// actually reads.
export default function Analytics() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    // Skip the very first render, GA's own auto page_view already covers
    // the initial load; this only needs to fire on actual navigations.
    if (first.current) {
      first.current = false;
      return;
    }
    analyticsPromise.then((analytics) => {
      if (!analytics) return;
      logEvent(analytics, 'page_view', {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    });
  }, [pathname]);

  return null;
}
